import * as React from 'react';

import ToastActions from 'actions/ToastActions';
import ConfirmDialog from 'components/ConfirmDialog';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import { useIntl } from 'lib/intl';

type Props = {
  group: Group;
  checkedIds: Backbone$Id[];
  onFinish?: () => void;
  onRequestHide?: () => void;
  userName?: string;
};

function AddGroupOwnerModalConfirm(props: Props) {
  const { checkedIds, group, onFinish, onRequestHide, userName } = props;
  const { formatMessage } = useIntl();

  const addOwners = () => {
    const successMessage = formatMessage(
      { id: 'admin.classSettings.addGroupOwnerModal.successText' },
      { ownersCount: checkedIds.length }
    );

    if (onRequestHide) {
      onRequestHide();
    }

    GroupActions.promoteGroupMemberships(group, checkedIds).then(
      () => {
        ToastActions.showSuccessToast(successMessage);
        if (onFinish) {
          onFinish();
        }
      },
      (e) => {
        const errorMessage =
          e.message ||
          formatMessage(
            { id: 'admin.classSettings.addGroupOwnerModal.errorText' },
            { name: group.getName() }
          );
        ToastActions.showErrorToast(errorMessage);
      }
    );
  };

  const ownersCount = checkedIds.length;
  let entity = formatMessage({ id: 'basic.a' });
  if (ownersCount > 1) {
    entity = `${ownersCount}`;
  } else if (userName) {
    entity = `${userName} ${formatMessage({ id: 'basic.as' })} ${formatMessage({ id: 'basic.a' })}`;
  }

  return (
    <ConfirmDialog
      eventScreenName="AddGroupOwnerModalConfirm"
      {...props}
      title={formatMessage(
        { id: 'admin.classSettings.addGroupOwnerModal.confirmText' },
        { entity, ownersCount }
      )}
      subtext={formatMessage({ id: 'admin.classSettings.addGroupOwnerModal.confirmSubtext' })}
      actionButtonText="Add"
      cancelButtonText="Cancel"
      onConfirm={addOwners}
    />
  );
}
export default AddGroupOwnerModalConfirm;
